import {useAppSelector} from "../../index";

export const useSelectedDiet = () => {
  return useAppSelector((state) => state.menu.selectedDiet);
}